<template>
    <div>
        <ValidationObserver ref="paymentFormValidate">
            <h6>{{ $t('payment_info') }}</h6>
            <div class="border p-4 rounded-sm mb-3">
                <b-row>
                    <b-col cols="12" v-if="paymentStatus">
                        <b-row>
                            <b-col cols="12" v-if="paymentHtml">
                                <iframe style="width: 100%; border: none; height: 38rem;" sandbox="allow-same-origin allow-top-navigation allow-forms allow-scripts"
                                        :srcdoc="paymentHtml" frameborder="1" id="payment-frame"></iframe>
                            </b-col>
                            <b-col cols="12" class="d-flex justify-content-center mb-3" v-else>
                                <b-spinner variant="primary" label="Spinning"></b-spinner>
                            </b-col>
                            <b-col cols="12" class="d-flex justify-content-center mb-3">
                                <b-button variant="primary" @click="close3dIframe">{{ $t('close') }}</b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" md="12">
                        <b-alert variant="dark" show>
                            <h3 class="mt-1" v-if="clubData.dues == null">{{ $t('payment_total')+' : 0 TL' }}</h3>
                            <h3 class="mt-1" v-else>{{ $t('payment_total')+' : '+clubData.dues+' TL' }}</h3>
                        </b-alert>
                        <b-alert variant="success" show v-if="clubData.status == 'E'">
                            <span class="font-size-20 font-weight-bold">{{$t('payment_success')}}</span>
                        </b-alert>
                    </b-col>
                    <b-col cols="12" md="12" v-show="!paymentStatus">
                        <div class="border p-4 rounded-sm mb-3">
                            <b-row>
                                <b-col cols="12" md="12">
                                    <b-form-group :label="$t('card_holder_name')">
                                        <ValidationProvider name="card_holder_name" rules="required" v-slot="{ errors }">
                                            <b-form-input v-model="paymentFormData.card_holder_name"
                                                          class="font-weight-bold text-center"
                                                          :state="errors[0] ? false : null" />
                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="12">
                                    <b-form-group :label="$t('card_number')">
                                        <ValidationProvider name="card_number" rules="required" v-slot="{ errors }">
                                            <b-form-input v-model="paymentFormData.card_number"
                                                          class="font-weight-bold text-center"
                                                          v-mask="'#### #### #### ####'"
                                                          :state="errors[0] ? false : null" />
                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <b-form-group :label="$t('expiry_month')">
                                        <ValidationProvider name="expiry_month" rules="required" v-slot="{ errors }">
                                            <multi-selectbox v-model="paymentFormData.expiry_month"
                                                             :options="expiryMonthOptions"
                                                             :multiple="false"
                                                             :validateError="errors[0]" />
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <b-form-group :label="$t('expiry_year')">
                                        <ValidationProvider name="expiry_year" rules="required" v-slot="{ errors }">
                                            <years-selectbox v-model="paymentFormData.expiry_year"
                                                             :up="true"
                                                             :interval="10"
                                                             :validateError="errors[0]" />
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <b-form-group label="CVV">
                                        <ValidationProvider name="cvv" rules="required" v-slot="{ errors }">
                                            <b-form-input v-model="paymentFormData.cvv"
                                                          class="font-weight-bold text-center"
                                                          v-mask="'###'"
                                                          :state="errors[0] ? false : null" />
                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="d-flex justify-content-center mt-3">
                <processing-button :processing="formLoading" variant="primary"
                                   :label="$t('make_payment').toUpper()" @click="makePayment" />
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    //Component

    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import StudentClubService from "@/services/StudentClubService"
    import ProcessingButton from "@/components/elements/ProcessingButton.vue";
    import YearsSelectbox from "@/components/interactive-fields/YearsSelectbox.vue";

    export default {
        props: {
            clubData: {
                type: Object,
            }
        },

        components: {
            YearsSelectbox,
            ProcessingButton,
            ValidationProvider,
            ValidationObserver,

        },

        data() {
            return {
                paymentFormData: {},
                formLoading: false,
                expiryMonthOptions: [
                    { value: '01', text: '01' },
                    { value: '02', text: '02' },
                    { value: '03', text: '03' },
                    { value: '04', text: '04' },
                    { value: '05', text: '05' },
                    { value: '06', text: '06' },
                    { value: '07', text: '07' },
                    { value: '08', text: '08' },
                    { value: '09', text: '09' },
                    { value: '10', text: '10' },
                    { value: '11', text: '11' },
                    { value: '12', text: '12' },
                ],
                paymentHtml: '',
                paymentStatus: false,
            }
        },

        methods: {
            async makePayment(){
                const isValid = await this.$refs.paymentFormValidate.validate()
                if (isValid) {
                    this.paymentStatus = true
                    this.formLoading = true
                    this.paymentFormData.card_number = this.paymentFormData.card_number.replaceAll(' ','')
                    let formData = {
                        ...this.paymentFormData,
                        student_club_student_id: this.clubData.id
                    }

                    StudentClubService.makePayment(formData).then(response => {
                        this.paymentHtml = response.data
                    }).catch(e => {
                        this.showErrors(e, this.$refs.paymentFormValidate)
                    })

                }
            },

            close3dIframe(){
                this.paymentStatus = false
                this.paymentHtml = ''
                this.formLoading = false
                //this.$emit('onUpdated', true)
            }
        },

        created() {

        },

    }
</script>
